import { Link } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-app bg-[#F9F8F6]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <span className="w-8 h-8 rounded-md bg-primary-app flex items-center justify-center text-white">
                <Building2 size={16} />
              </span>
              <span className="font-serif text-xl font-semibold text-app">PortalFinca</span>
            </Link>
            <p className="text-sm text-app-secondary leading-relaxed max-w-xs">
              {t.footer.tagline}
            </p>
          </div>

          <div>
            <h4 className="label-eyebrow mb-4">{t.footer.product}</h4>
            <ul className="space-y-2.5">
              {t.footer.links.map((l, i) => (
                <li key={i}>
                  <span className="text-sm text-app-secondary hover:text-app cursor-pointer transition-colors">
                    {l}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="label-eyebrow mb-4">{t.footer.company}</h4>
            <ul className="space-y-2.5">
              {t.footer.companyLinks.map((l, i) => (
                <li key={i}>
                  <span className="text-sm text-app-secondary hover:text-app cursor-pointer transition-colors">
                    {l}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="label-eyebrow mb-4">{t.footer.legal}</h4>
            <ul className="space-y-2.5">
              {t.footer.legalLinks.map((l, i) => (
                <li key={i}>
                  <span className="text-sm text-app-secondary hover:text-app cursor-pointer transition-colors">
                    {l}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-app flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
          <p className="text-xs text-app-muted">{t.footer.copy}</p>
          <p className="text-xs text-app-muted">PortalFinca · v0.1 Beta</p>
        </div>
      </div>
    </footer>
  );
}
